import {Observable, Subscription} from 'rxjs';

import ITimelineStore from '../Interfaces/ITimelineStore';

const subscribeToTimelineScrub = (
    timelineScrub$: Observable<number>,
    timelineStore: ITimelineStore
): Subscription =>
    timelineScrub$
        .subscribe((multiplier: number) => timelineStore.actions.scrub(multiplier));

export default subscribeToTimelineScrub;